var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"disabled":_vm.btn_disabled,"type":_vm.typeStyle,"size":_vm.size,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"loading":_vm.fLoading,"icon":_vm.icon,"autofocus":false},on:{"click":function($event){return _vm.handleClick(_vm.clickEvent)}}},[_vm._v(" "+_vm._s(_vm.fContent)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }